import React from 'react'
import { IconFacebook, IconLinkdin, IconInstagramStroke, IconX } from '@/icons'

const getSocials = () => [
  {
    key: 1,
    icon: <IconLinkdin />,
    link: 'https://www.linkedin.com/company/2413674/',
    ariaLabel: 'Visite nosso LinkedIn',
  },
  {
    key: 2,
    icon: <IconInstagramStroke />,
    link: 'https://www.instagram.com/sympla/',
    ariaLabel: 'Visite nosso Instagram',
  },
  {
    key: 3,
    icon: <IconX />,
    link: 'https://twitter.com/sympla/',
    ariaLabel: 'Visite nosso Twitter',
  },
  {
    key: 4,
    icon: <IconFacebook />,
    link: 'https://www.facebook.com/sympla',
    ariaLabel: 'Visite nosso Facebook',
  },
]

export default getSocials
